import React from 'react';
import { graphql } from 'gatsby';

import Website from 'components/ui-setup';
import Layout from 'components/layout';
import Models from 'components/models';

type Props = {
  data: Object,
};

const ModelsPage = ({ data }: Props) => {
  const {
    modelsJson,
    getInTouchJson,
    logoJson,
    socialMediaJson,
    siteJson,
    cookieConsentJson,
  } = data;

  return (
    <Website
      content={{
        ...modelsJson,
        getInTouch: getInTouchJson,
        cookieConsent: cookieConsentJson,
        menu: siteJson?.content,
        logo: logoJson,
        socialMedia: socialMediaJson,
      }}>
      <Layout>
        <Models />
      </Layout>
    </Website>
  );
};

export default ModelsPage;

export const query = graphql`
  query ModelsPageQuery {
    modelsJson {
      hero {
        background {
          image {
            xl
            lg
            md
            sm
            xs
          }
        }
        title
      }
      extendedTeam {
        card {
          id
          title
          content
          list {
            title
            items
          }
        }
        image
      }
      managedTeam {
        card {
          id
          title
          content
          list {
            title
            items
          }
        }
        image
      }
      coaching {
        card {
          id
          title
          content
          list {
            title
            items
          }
        }
        image
      }
      meta {
        description
        title
      }
    }
    getInTouchJson {
      ...GetInTouchJsonFragment
    }
    siteJson {
      ...SiteJsonFragment
    }
    cookieConsentJson {
      ...CookieConsentJsonFragment
    }
    logoJson {
      ...LogoJsonFragment
    }
    socialMediaJson {
      ...SocialMediaJsonFragment
    }
  }
`;
